import {useLocation, useNavigate} from 'react-router-dom';
import {FormEvent, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {useAuth} from '../../../../../context/authContext';
import {getLatLng} from '../../../../../utilities/helper/getLatLng';
import LocationalCustomMap from '../../../../farm/locationalCustomMap';
import {addAddress} from '../../../../../store/redux/saleAgentsSelectedLocation';
import FloatingSearchBox from '../../../../../components/mazraeKit/floatingSearchBox';
import useGetAddressByLatLngSearch from '../../../../../services/hookService/getAddressByLatLngSearch/useGetAddressByLatLngSearch';

const SaleAgentLocationByMap = () => {
  const navigate = useNavigate();

  const {supplierProfile} = useAuth();
  const {state} = useLocation();

  const dispatch = useDispatch();
  // const selectLocation = useSelector(
  //   (state: RootState) => state.saleAgentsLocation,
  // );
  const [latlng, setLatLng] = useState({
    lng: supplierProfile?.latlong[1] as string,
    lat: supplierProfile?.latlong[0] as string,
  });

  useEffect(() => {
    if (state?.location) {
      if (typeof state?.location === 'string') {
        const location = getLatLng(state?.location as string);
        setLatLng({lng: location[0], lat: location[1]});
      } else if (state.location.length > 0) {
        setLatLng({lng: state?.location[0], lat: state?.location[1]});
      }
    }
  }, [state?.location, supplierProfile?.latlong]);

  const {address} = useGetAddressByLatLngSearch(latlng.lng, latlng.lat);
  const [inputValue, setInputValue] = useState<string>(
    address?.city?.name as string,
  );

  useEffect(() => {
    setInputValue(address?.city?.name as string);
  }, [address, address?.city.name]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    navigate('/sale-agent-searching-location', {
      state: {
        searchBarAddress: e.target.value,
        assigner_store: state.assigner_store,
      },
    });
    setInputValue(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(
      addAddress({
        location: getLatLng(address?.city?.location as string),
        name: address?.city.name,
      }),
    );
    navigate(`/sale-agents/${state.assigner_store}`, {
      state: {
        cardGuid: state.cardGuid,
      },
    });
  };

  return (
    <form className="w-full h-full px-3" onSubmit={handleSubmit}>
      <div className="flex justify-between h-14 items-center  border-b border-gray-200">
        <span>آدرس فروشگاه </span>
        <i
          className="icon-nameClose-remove text-xl font-Bold"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>
      <FloatingSearchBox
        label="جستجوی آدرس"
        type="text"
        value={inputValue}
        onChange={onChangeHandler}
        {...{inputValue, setInputValue}}
      />
      <div
        className="rounded mt-4 overflow-y-auto"
        style={{height: `calc(100% - 245px)`}}
      >
        <LocationalCustomMap
          location={state.location?.location}
          {...{latlng, setLatLng}}
        />
      </div>
      <button
        className="text-white rounded w-full mt-4 bg-farm-shop-500 py-3"
        type="submit"
      >
        ذخیره آدرس
      </button>
    </form>
  );
};

export default SaleAgentLocationByMap;
